export function Section({ children, className = "", ...rest }) {
  return (
    <section className={`max-w-7xl mx-auto px-6 ${className}`} {...rest}>
      {children}
    </section>
  );
}

export function Eyebrow({ children, className = "" }) {
  return <div className={`label-eyebrow ${className}`}>{children}</div>;
}

export function SectionTitle({ eyebrow, title, sub, align = "left", className = "" }) {
  return (
    <div className={`${align === "center" ? "text-center mx-auto max-w-3xl" : ""} ${className}`}>
      {eyebrow && <Eyebrow className="mb-4">{eyebrow}</Eyebrow>}
      <h2 className="heading-xl text-3xl sm:text-4xl lg:text-5xl text-[#1A1A1A]">{title}</h2>
      {sub && <p className="mt-4 text-gray-600 max-w-2xl text-base leading-relaxed">{sub}</p>}
    </div>
  );
}
